import { render } from "./Cogs.vue?vue&type=template&id=5417bbdc&scoped=true"
import script from "./Cogs.vue?vue&type=script&lang=js"
export * from "./Cogs.vue?vue&type=script&lang=js"

import "./Cogs.vue?vue&type=style&index=0&id=5417bbdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5417bbdc"]])

export default __exports__